import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';
import { OrderdetailsPage } from '../../pages/orderdetails/orderdetails';

@Component({
  selector: 'page-reportlist',
  templateUrl: 'reportlist.html',
})
export class ReportlistPage {
today_list: any =[];
today_date: any;
start_date: any;
end_date: any;
active:any;
order_type;

pageNo = 0;
loadMoreData = false;
pageNos = false;
Isorder;

counter;

  constructor(public DBservice: DbservicesProvider,public navCtrl: NavController, public navParams: NavParams) {
  this.order_type = 'today';
  var date;
	var aa = new Date();
	
	date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
	this.end_date = date;
	this.start_date = date;
  this.daily_sales(this.pageNo);
  this.today_count();
  }

  today_count(){
    var date;
    var aa = new Date();
    date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
    this.end_date = date;
    this.start_date = date;
    var res={
      count_based_on:'name',
      start_date:this.start_date,
      end_date:this.end_date,
      business: localStorage.restaurant,
      status_list: 'Completed'
    }
    this.DBservice.order_count(res)
      .then(data => {
        console.log(data)
        if(data.message != undefined)
          this.counter = data.message[0]
      })
  }

  getPaddedComp(comp) {
    return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
  }

  back(){
  	this.navCtrl.pop();
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ReportlistPage');
  }
  orderdetail(list) {
    this.navCtrl.push('OrderdetailsPage', { item: list })
  }

  doInfinite(infiniteScroll) {
    if (this.pageNos == true) {
      this.pageNo = this.pageNo + 10;
      this.daily_sales(this.pageNo);
    }
    setTimeout(() => {
      infiniteScroll.complete();
    }, 50);
  }

  order_tab(index){
    if(index == 0){
      this.pageNo = 0;
      this.loadMoreData = false;
      this.pageNos = false;
      this.Isorder;
      this.today_list = [];
      var date;
      var aa = new Date();
      date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
      this.end_date = date;
      this.start_date = date;
      this.daily_sales(this.pageNo)
    }
    else if(index == 1){

    }

  }

  thisweek(){
    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    this.start_date = new Date(curr.setDate(first)).toUTCString(); 
    this.end_date = new Date(curr.setDate(last)).toUTCString();
    this.pageNo = 0;
    this.loadMoreData = false;
    this.pageNos = false;
    this.Isorder;
    this.today_list = []
    this.daily_sales(this.pageNo)
  }

    daily_sales(page){    
    let filters = {
      restaurantId:localStorage.restaurant,
      limit_start: page,
      start_date:this.start_date,
      end_date:this.end_date,
      limit_page_length: 10,
      status: 'Completed'
    };
    this.DBservice.order_list(filters)
      .then(data => {
        if (data.message != undefined) {
          for (var i = 0; i < data.message.length; i++) {
            var k = i;
            this.today_list.push(data.message[k])
          }
          console.log(this.today_list);
          if (data.message.length == 0) {
            this.loadMoreData = true;
          }
          if(this.today_list.length == 0)
            this.Isorder = true;
          this.pageNos = true
        }
        else {
          this.Isorder = true;
          this.pageNos = false;
          this.loadMoreData = true;

        }
        if(this.today_list.length != 0)
          this.Isorder = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reportlist/reportlist.ts